import { StyledHeaderForm } from "../../styled/HeaderForm";

const HeaderForm = ({ title, rightText }) => {
  return (
    <StyledHeaderForm.TitleContainer style={{ position: "relative" }}>
      <StyledHeaderForm.Text>{title}</StyledHeaderForm.Text>
      {rightText && (
        <StyledHeaderForm.Text style={{ position: "absolute", right: 20 }}>
          {rightText}
        </StyledHeaderForm.Text>
      )}
    </StyledHeaderForm.TitleContainer>
  );
};
export default HeaderForm;
